import { render } from "./PlayerGrid.vue?vue&type=template&id=0420d696&scoped=true"
const script = {}

import "./PlayerGrid.vue?vue&type=style&index=0&id=0420d696&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0420d696"]])

export default __exports__